// extracted by mini-css-extract-plugin
module.exports = {"row2Cols":"pages-module--row2Cols--3_ljz","reverseOnMobile":"pages-module--reverseOnMobile--1jbHR"};